import type { StartAppListening } from '@/store/listenerMiddleware.ts';
import { registerAlgoCommandListener } from '@/store/orders/algoOrders/listener.ts';

export function registerOrderListeners(startAppListening: StartAppListening): void {
  registerAlgoCommandListener(startAppListening);
}
